import script from "./opTableServerSide.vue?vue&type=script&lang=ts"
export * from "./opTableServerSide.vue?vue&type=script&lang=ts"

const __exports__ = script;

export default __exports__